import React, { useEffect } from 'react'
import { Nav, Navbar, NavDropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { LOGOUT_USER } from 'constants/action-types'
import logo from 'images/logo-refresh-small.png'
import './navigation-bar.css'
import { RootState } from 'index'

const NavigationBar = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector((state: RootState) => state.user.currentUser)
  const history = useHistory()
  const location = useLocation()

  const handleLogoutClick = () => {
    const confirmed = window.confirm('Are you sure you want to log out?')
    if (confirmed) {
      dispatch({
        type: LOGOUT_USER,
      })
    }
  }

  const handlePOBuilderToggle = () => {
    const queryParams = new URLSearchParams(location.search)
    const dealid = location.pathname.match(
      /\/subscription-purchase-link\/(\d+)/
    )?.[1]
    const dealNameFromUrl = queryParams.get('dealName')

    const path = `/subscription-purchase-link${dealid ? `/${dealid}` : ''}`
    const queryString = dealNameFromUrl
      ? `?dealName=${encodeURIComponent(dealNameFromUrl)}`
      : ''
    history.push(path + queryString)
  }

  return (
    <Navbar
      className="pr-3"
      fixed="top"
      collapseOnSelect
      expand="lg"
      bg="dark"
      variant="dark"
    >
      <Navbar.Brand as={Link} to="/home">
        <img src={logo} className="app-logo" alt="logo" />
      </Navbar.Brand>
      {currentUser ? (
        <>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="justify-content-start mr-auto">
              <Nav.Link eventKey="home" as={Link} to="/home">
                Home
              </Nav.Link>
              <Nav.Link eventKey="users" as={Link} to="/users">
                Users
              </Nav.Link>
              <Nav.Link eventKey="sandboxes" as={Link} to="/sandboxes">
                Sandbox
              </Nav.Link>
              <Nav.Link eventKey="cli-users" as={Link} to="/cli-users">
                CLI
              </Nav.Link>
              <Nav.Link eventKey="organizations" as={Link} to="/organizations">
                Organizations
              </Nav.Link>
              <NavDropdown
                title="Stripe Link Builders"
                id="collasible-nav-dropdown"
              >
                <Nav.Link
                  eventKey="purchase-order-builder"
                  as={Link}
                  to="/subscription-purchase-order"
                >
                  Purchase Order Builder
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="non-subscription-purchase-link"
                  as={Link}
                  to="/non-subscription-purchase-link"
                >
                  Non Subscription Link Builder
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="organizations-missing-info"
                  as={Link}
                  to="/organizations-missing-info"
                >
                  Organizations Missing Info
                </Nav.Link>
              </NavDropdown>

              <Nav.Link eventKey="products" as={Link} to="/products">
                Products
              </Nav.Link>
              {/*
              <Nav.Link eventKey="inventory" as={Link} to="/inventory">
                Inventory
              </Nav.Link>
*/}
              <NavDropdown title="Zakeke" id="collasible-nav-dropdown">
                <Nav.Link
                  eventKey="zakeke_orders"
                  as={Link}
                  to="/zakeke_orders"
                >
                  Orders
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link eventKey="print_files" as={Link} to="/print_files">
                  Print Files
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="zakeke_products"
                  as={Link}
                  to="/zakeke_products"
                >
                  Zakeke Products
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="product-jig-templates"
                  as={Link}
                  to="/product-jig-templates"
                >
                  Product Jig Templates
                </Nav.Link>
              </NavDropdown>

              <NavDropdown title="Tools" id="collasible-nav-dropdown">
                <Nav.Link eventKey="bug-reporter" as={Link} to="/bug-reporter">
                  Bug Reporter
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="entitlement-groupings"
                  as={Link}
                  to="/entitlement-groupings"
                >
                  Entitlement Groupings
                </Nav.Link>
              </NavDropdown>
            </Nav>
            <Nav className="justify-content-end">
              <NavDropdown
                title={currentUser.name}
                id="collasible-nav-dropdown"
              >
                <Nav.Link eventKey="account" as={Link} to="/account">
                  Account
                </Nav.Link>
                <NavDropdown.Divider />
                <Nav.Link
                  eventKey="logout"
                  as={Link}
                  to={{}}
                  onClick={handleLogoutClick}
                >
                  Logout
                </Nav.Link>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </>
      ) : (
        <></>
      )}
    </Navbar>
  )
}

export default NavigationBar
